export default __webpack_public_path__ + "static/media/logo.6720e4c9.png";